// Casa Nuvé — newsletter popup behavior
(function () {
  'use strict';
  var root = document.documentElement;
  var STORAGE_KEY = 'casaNuvePopupDismissedAt';
  var DAYS_BEFORE_RESHOW = 30;
  var DELAY_MS = 15000;

  function openPopup() { root.setAttribute('data-popup-open', ''); }
  function closePopup() {
    root.removeAttribute('data-popup-open');
    try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-popup-close-btn]')) { closePopup(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePopup(); }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('.popup-card');
    if (!popup) return;



    var dismissed = null;
    try { dismissed = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (dismissed) {
      var elapsedDays = (Date.now() - parseInt(dismissed, 10)) / 86400000;
      if (elapsedDays < DAYS_BEFORE_RESHOW) return;
    }
    setTimeout(openPopup, DELAY_MS);
  });
})();



// Casa Nuve - product gallery lightbox
(function () {
  'use strict';

  function setupProductLightbox() {
    if (document.querySelector('[data-casa-nuve-lightbox]')) return;

    var gallery = document.querySelector('[data-gallery]');
    var mainImage = document.querySelector('[data-gallery-main] img[data-zoomable]');
    if (!gallery || !mainImage) return;

    var lightbox = document.createElement('div');
    lightbox.setAttribute('data-casa-nuve-lightbox', '');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product image zoom');
    lightbox.hidden = true;
    lightbox.innerHTML = '<button type=\"button\" data-casa-nuve-lightbox-close aria-label=\"Close image zoom\">&times;</button><img alt=\"\">';
    document.body.appendChild(lightbox);

    var zoomImage = lightbox.querySelector('img');
    var closeButton = lightbox.querySelector('[data-casa-nuve-lightbox-close]');

    function openLightbox() {
      zoomImage.src = mainImage.currentSrc || mainImage.src;
      zoomImage.alt = mainImage.alt || '';
      lightbox.hidden = false;
      document.documentElement.classList.add('casa-nuve-lightbox-open');
      closeButton.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      document.documentElement.classList.remove('casa-nuve-lightbox-open');
      mainImage.focus();
    }

    mainImage.setAttribute('tabindex', '0');
    mainImage.setAttribute('role', 'button');
    mainImage.setAttribute('aria-label', 'Open product image zoom');
    mainImage.addEventListener('click', openLightbox);
    mainImage.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openLightbox();
      }

    });

    closeButton.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupProductLightbox);
  } else {
// Open product thumbnails directly in the image lightbox.
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;

    var mainImage = document.querySelector('[data-gallery-main] img[data-zoomable]');
    var lightbox = document.querySelector('[data-casa-nuve-lightbox]');
    if (!mainImage || !lightbox) return;

    var fullImage = thumb.getAttribute('data-full') || thumb.currentSrc || thumb.src;
    mainImage.src = fullImage;
    mainImage.removeAttribute('srcset');
    mainImage.alt = thumb.alt || mainImage.alt || '';

    document.querySelectorAll('[data-gallery-thumb]').forEach(function (item) {
      item.classList.toggle('is-active', item === thumb);
    });

    var zoomImage = lightbox.querySelector('img');
    var closeButton = lightbox.querySelector('[data-casa-nuve-lightbox-close]');
    zoomImage.src = fullImage;
    zoomImage.alt = mainImage.alt;
    lightbox.hidden = false;
    document.documentElement.classList.add('casa-nuve-lightbox-open');
    closeButton.focus();
  });
})();

    setupProductLightbox();
  }
})();

// Casa Nuve - accessible product gallery carousel enhancement
(function () {
  'use strict';

  function setupCasaNuveCarousel() {
    var gallery = document.querySelector('[data-gallery]');
    var lightbox = document.querySelector('[data-casa-nuve-lightbox]');
    if (!gallery || !lightbox || lightbox.querySelector('[data-casa-nuve-lightbox-prev]')) return;

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var mainImage = gallery.querySelector('[data-gallery-main] img[data-zoomable]');
    var zoomImage = lightbox.querySelector('img');
    if (!thumbs.length || !mainImage || !zoomImage) return;

    var currentIndex = Math.max(0, thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    }));

    var previousButton = document.createElement('button');
    previousButton.type = 'button';
    previousButton.setAttribute('data-casa-nuve-lightbox-prev', '');
    previousButton.setAttribute('aria-label', 'Previous product image');
    previousButton.innerHTML = '&#8249;';

    var nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.setAttribute('data-casa-nuve-lightbox-next', '');
    nextButton.setAttribute('aria-label', 'Next product image');
    nextButton.innerHTML = '&#8250;';

    var counter = document.createElement('div');
    counter.setAttribute('data-casa-nuve-lightbox-counter', '');
    counter.setAttribute('aria-live', 'polite');

    lightbox.appendChild(previousButton);
    lightbox.appendChild(nextButton);
    lightbox.appendChild(counter);

    function cleanImageUrl(url) {
      return (url || '').replace(/&width=\d+/, '&width=1800').replace(/\?width=\d+/, '?width=1800');
    }

    function showImage(index, moveFocus) {
      currentIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[currentIndex];
      var fullImage = cleanImageUrl(thumb.getAttribute('data-full') || thumb.currentSrc || thumb.src);

      mainImage.src = fullImage;
      mainImage.removeAttribute('srcset');
      mainImage.alt = thumb.alt || mainImage.alt || '';
      zoomImage.src = fullImage;
      zoomImage.alt = mainImage.alt;

      thumbs.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === currentIndex);
        item.setAttribute('aria-current', itemIndex === currentIndex ? 'true' : 'false');
      });

      counter.textContent = (currentIndex + 1) + ' / ' + thumbs.length;
      if (moveFocus) zoomImage.focus();
    }

    thumbs.forEach(function (thumb, index) {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('aria-label', 'Open product image ' + (index + 1) + ' of ' + thumbs.length);
      thumb.addEventListener('click', function () {
        currentIndex = index;
        showImage(currentIndex, false);
      });
      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          thumb.click();
        }
      });
    });

    mainImage.addEventListener('click', function () {
      var activeIndex = thumbs.findIndex(function (thumb) {
        return thumb.classList.contains('is-active');
      });
      showImage(activeIndex < 0 ? currentIndex : activeIndex, false);
    });

    previousButton.addEventListener('click', function () {
      showImage(currentIndex - 1, false);
    });
    nextButton.addEventListener('click', function () {
      showImage(currentIndex + 1, false);
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentIndex - 1, false);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentIndex + 1, false);
      }
    });

    showImage(currentIndex, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCasaNuveCarousel);
  } else {
    setupCasaNuveCarousel();
  }
})();
